module.exports = __webpack_public_path__ + "img/shichi-go-san school visit.1d8e2a02.png";